(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodSlick', sodSlick);

    function sodSlick($document, $rootScope, lodash) {
        return {
            restrict: 'A',
            scope: { config: '=' },
            link: sodSlickLink,
        };

        function sodSlickLink(scope, elem, attr) {

            init();
            function init() {
                var sodSlickId = randomString(8);
                $document.ready(function () {
                    setSlickId(sodSlickId);

                    $rootScope.$on(
                        ['sod-slick', sodSlickId, 'init'].join('.'),
                        function (delay) {
                            setTimeout(function () {
                                initSlick(sodSlickId);
                            }, delay || 300);
                        }
                    );

                    scope.$on('$destroy', function() {
                        destroySlick(sodSlickId);
                    });

                });
            }

            function setSlickId(sodSlickId) {
                var sodSlickChildElem = elem.find('[sod-slick-child]');
                sodSlickChildElem.attr('sod-slick-child', sodSlickId);
            }

            function destroySlick(sodSlickId) {
                $('.sod-slick-' + sodSlickId).slick('unslick');
            }

            function initSlick(sodSlickId) {
                $('.sod-slick-' + sodSlickId).slick('unslick');
                var sodSlickElem = elem.find('.sod-slick');
                sodSlickElem.addClass('sod-slick-' + sodSlickId);
                var slickOptions = lodash.get(scope, 'config', {});
                $('.sod-slick-' + sodSlickId).slick(slickOptions);

                var isForceCenterMode = lodash.get(slickOptions, 'forceCenterMode', false);
                if (isForceCenterMode) {
                    $('.sod-slick-' + sodSlickId).on('breakpoint', cbForceCenterMode);
                    $('.sod-slick-' + sodSlickId).on('setPosition', cbForceCenterMode);
                    $('.sod-slick-' + sodSlickId).on('init', cbForceCenterMode);
                    $('.sod-slick-' + sodSlickId).on('reInit', cbForceCenterMode);

                    $('.sod-slick-' + sodSlickId).on('destroy', function () {
                        $('.sod-slick-' + sodSlickId).off('breakpoint');
                        $('.sod-slick-' + sodSlickId).off('setPosition');
                        $('.sod-slick-' + sodSlickId).off('init');
                        $('.sod-slick-' + sodSlickId).off('reInit');
                    });

                    setTimeout(cbForceCenterMode, 300);
                }

                function cbForceCenterMode() {
                    forceCenterMode();
                }

                function forceCenterMode() {
                    var slick = $('.sod-slick-' + sodSlickId).slick('getSlick');
                    var activeBreakpoint = lodash.get(slick, 'activeBreakpoint', null);

                    var slidesToShow = null;
                    if (activeBreakpoint) {
                        slidesToShow = lodash.get(slick, ['breakpointSettings', activeBreakpoint, 'slidesToShow'].join('.'), null);
                    } else {
                        slidesToShow = lodash.get(slickOptions, 'slidesToShow', null);
                    }

                    var slidesCount = lodash.get(slick, '$slides.length', null);
                    if (slidesCount < slidesToShow) {
                        var $slideTrack = lodash.get(slick, '$slideTrack', null);
                        $slideTrack.css('width', '');
                    }
                }
            }

            function randomString(length) {
                return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
            }
        }
    }
})();